import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import GlobalLoader from '@configuratorware/configurator-frontendgui/App/Shared/Containers/GlobalLoader';

const useStyles = makeStyles(
  (theme) => ({
    container: {
      paddingTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      width: '100%',
      margin: 'auto',
      position: 'relative',
    },
    fullWidth: {
      width: '100%',
      paddingTop: 0,
      paddingBottom: 0,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    header: {
      minHeight: theme.spacing(8),
      display: 'flex',
      justifyContent: 'center',
      paddingLeft: '25px',
      background: 'transparent',
      border: 0,
    },
    headline: {
      fontWeight: 'bold',
    },
  }),
  { name: 'MainContainer' }
);

interface ScreenLayoutProps {
  title?: string;
  appBarContent?: React.ReactNode;
  fullWidth?: boolean;
  children: React.ReactNode;
}

export const ScreenLayout: React.FC<ScreenLayoutProps> = ({
  title,
  appBarContent,
  fullWidth = false,
  children,
}) => {
  const classes = useStyles();

  return (
    <>
      {(appBarContent || title) && (
        <AppBar color="default" className={classes.header} position={'fixed'} variant={'outlined'}>
          {appBarContent}
          {title && (
            <Typography className={classes.headline} variant="h5">
              {title}
            </Typography>
          )}
        </AppBar>
      )}
      <div className={clsx(classes.container, fullWidth && classes.fullWidth)}>{children}</div>
      <GlobalLoader />
    </>
  );
};

export default ScreenLayout;
